export default {
  list: [],
  profiles: [],
  enterprises: [],
  errors: null,
  agent: null
};
